import React, { useState } from 'react';
import { Card } from '../../SubscriptionAppCard';
import { Input } from '../../SubscriptionAppInput';
import { Button } from '../../SubscriptionAppButton';
import { FormData } from './hooks/useSubscriptionForm';
export interface AddressFormProps {
  type: 'shipping' | 'billing';
  formData: FormData;
  onChange: (field: keyof FormData, value: string) => void;
  disabled: boolean;
  'data-id'?: string;
}
export function AddressForm({
  type,
  formData,
  onChange,
  disabled,
  'data-id': dataId
}: AddressFormProps) {
  const prefix = type === 'shipping' ? 'shipping' : 'billing';
  const title = type === 'shipping' ? 'Shipping Address' : 'Billing Address';
  const getField = (suffix: string) => `${prefix}${suffix}` as keyof FormData;
  return <Card padding="none" data-id="element-2742">
      <div className="p-6 border-b border-[#E2E8F0] bg-gradient-to-r from-[#F8FAFC] to-white" data-id="element-2743">
        <h3 className="text-[20px] font-semibold text-[#0F172A]" data-id="element-2744">{title}</h3>
      </div>
      <div className="p-6 space-y-4 bg-white" data-id="element-2745">
        <div className="grid grid-cols-2 gap-4" data-id="element-2746">
          <Input label="First Name" value={formData[getField('FirstName')]} onChange={e => onChange(getField('FirstName'), e.target.value)} disabled={disabled} data-id="element-2747" />
          <Input label="Last Name" value={formData[getField('LastName')]} onChange={e => onChange(getField('LastName'), e.target.value)} disabled={disabled} data-id="element-2748" />
        </div>
        <Input label="Address Line 1" value={formData[getField('Address1')]} onChange={e => onChange(getField('Address1'), e.target.value)} disabled={disabled} data-id="element-2749" />
        <Input label="Address Line 2" value={formData[getField('Address2')]} onChange={e => onChange(getField('Address2'), e.target.value)} disabled={disabled} data-id="element-2750" />
        <div className="grid grid-cols-2 gap-4" data-id="element-2751">
          <Input label="City" value={formData[getField('City')]} onChange={e => onChange(getField('City'), e.target.value)} disabled={disabled} data-id="element-2752" />
          <Input label="Post Code" value={formData[getField('PostCode')]} onChange={e => onChange(getField('PostCode'), e.target.value)} disabled={disabled} data-id="element-2753" />
        </div>
      </div>
    </Card>;
}